import axios from "axios";
import Config from "../../../config/index";
import {
  CREATE_INDUSTRY_REQUEST,
  CREATE_INDUSTRY_SUCCESS,
  CREATE_INDUSTRY_FAILURE,
  GET_ALL_INDUSTRY_REQUEST,
  GET_ALL_INDUSTRY_SUCCESS,
  GET_ALL_INDUSTRY_FAILURE,
  GET_ONE_INDUSTRY_REQUEST,
  GET_ONE_INDUSTRY_SUCCESS,
  GET_ONE_INDUSTRY_FAILURE,
  EDIT_INDUSTRY_REQUEST,
  EDIT_INDUSTRY_SUCCESS,
  EDIT_INDUSTRY_FAILURE,
  DELETE_INDUSTRY_REQUEST,
  DELETE_INDUSTRY_SUCCESS,
  DELETE_INDUSTRY_FAILURE,
  UPLOADCSV_INDUSTRY_MASTER_REQUEST,
  UPLOADCSV_INDUSTRY_MASTER_SUCCESS,
  UPLOADCSV_INDUSTRY_MASTER_FAILURE,
} from "./industryMasterTypes";  

let baseUrl = Config.baseUrl;
let baseUrlFileUploadTemp = Config.baseUrlFileUploadTemp;

// --- CREATE API ---
const createIndustryRequest = () => ({
  type: CREATE_INDUSTRY_REQUEST,
});
const createIndustrySuccess = (payload) => ({
  type: CREATE_INDUSTRY_SUCCESS,
  payload,
});
const createIndustryFailure = (error) => ({
  type: CREATE_INDUSTRY_FAILURE,
  payload: error,
});

const createIndustryMaster = (payload, jwtToken) => {
  let headers = { headers: { Authorization: `Bearer ${jwtToken}` } };

  return (dispatch) => {
    dispatch(createIndustryRequest());
    let url = `${baseUrl}/dpp/industry_master/create`;

    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createIndustrySuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createIndustryFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

// --- GET ALL API ---
const getAllIndustryRequest = () => ({
  type: GET_ALL_INDUSTRY_REQUEST,
});
const getAllIndustrySuccess = (payload) => ({
  type: GET_ALL_INDUSTRY_SUCCESS,
  payload,
});
const getAllIndustryFailure = (error) => ({
  type: GET_ALL_INDUSTRY_FAILURE,
  payload: error,
});

const getAllIndustryMaster = (jwtToken) => {
  let headers = { headers: { Authorization: `Bearer ${jwtToken}` } };

  return (dispatch) => {
    dispatch(getAllIndustryRequest());
    let url = `${baseUrl}/dpp/industry_master/get`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getAllIndustrySuccess(response.data));
      })
      .catch((err) => {
        dispatch(getAllIndustryFailure(err.message));
      });
  };
};

// --- GET ONE API ---
const getOneIndustryRequest = () => ({
  type: GET_ONE_INDUSTRY_REQUEST,
});
const getOneIndustrySuccess = (payload) => ({
  type: GET_ONE_INDUSTRY_SUCCESS,
  payload,
});
const getOneIndustryFailure = (error) => ({
  type: GET_ONE_INDUSTRY_FAILURE,
  payload: error,
});

const getOneIndustryMaster = (industryId, jwtToken) => {
  let headers = { headers: { Authorization: `Bearer ${jwtToken}` } };

  return (dispatch) => {
    dispatch(getOneIndustryRequest());
    let url = `${baseUrl}/dpp/industry_master/get_one?industryId=${industryId}`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getOneIndustrySuccess(response.data));
      })
      .catch((err) => {
        dispatch(getOneIndustryFailure(err.message));
      });
  };
};

// --- EDIT API ---
const editIndustryRequest = () => ({
  type: EDIT_INDUSTRY_REQUEST,
});
const editIndustrySuccess = (payload) => ({
  type: EDIT_INDUSTRY_SUCCESS,
  payload,
});
const editIndustryFailure = (error) => ({
  type: EDIT_INDUSTRY_FAILURE,
  payload: error,
});

const editIndustryMaster = (payload, jwtToken) => {
  let headers = { headers: { Authorization: `Bearer ${jwtToken}` } };

  return (dispatch) => {
    dispatch(editIndustryRequest());
    let url = `${baseUrl}/dpp/industry_master/update`;

    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(editIndustrySuccess(response));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(editIndustryFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

// --- DELETE API ---
const deleteIndustryRequest = () => ({
  type: DELETE_INDUSTRY_REQUEST,
});
const deleteIndustrySuccess = (payload) => ({
  type: DELETE_INDUSTRY_SUCCESS,
  payload,
});
const deleteIndustryFailure = (error) => ({
  type: DELETE_INDUSTRY_FAILURE,
  payload: error,
});

const deleteIndustryMaster = (industryId, udBy, jwtToken) => {
  let headers = { headers: { Authorization: `Bearer ${jwtToken}` } };

  return (dispatch) => {
    dispatch(deleteIndustryRequest());
    let url = `${baseUrl}/dpp/industry_master/delete?industryId=${industryId}&udBy=${udBy}`;

    return axios
      .delete(url, headers)
      .then((response) => {
        dispatch(deleteIndustrySuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(deleteIndustryFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};


const uploadCsvForIndustryMasterRequest = () => ({
  type: UPLOADCSV_INDUSTRY_MASTER_REQUEST,
});

const uploadCsvForIndustryMasterSuccess = (payload) => ({
  type: UPLOADCSV_INDUSTRY_MASTER_SUCCESS,
  payload: payload,
});

const uploadCsvForIndustryMasterFailure = (error) => ({
  type: UPLOADCSV_INDUSTRY_MASTER_FAILURE,
  payload: error,
});

  const uploadCsvForIndustryMaster = (payload, jwtToken) => {
  let headers = {
    headers: { Authorization: `Bearer ${jwtToken}` },
  };
  return (dispatch) => {
    dispatch(uploadCsvForIndustryMasterRequest());
    let url = `${baseUrlFileUploadTemp}/dpp/industry_master/upload`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(uploadCsvForIndustryMasterSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(uploadCsvForIndustryMasterFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

export {
  createIndustryMaster,
  getAllIndustryMaster,
  getOneIndustryMaster,
  editIndustryMaster,
  deleteIndustryMaster,
  uploadCsvForIndustryMaster,
};